// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout_container__2PWs_","leftContainer":"MainLayout_leftContainer__2JEpV","rightContainer":"MainLayout_rightContainer__3VjhM"};